<template>
  <el-card class="box-card order-detail-section">
    <el-table :data="list" size="small" v-loading="loading">
      <el-table-column
        prop="id"
        label="学校ID"
        width="100px"
      ></el-table-column>
      <el-table-column prop="name" label="学校名称"></el-table-column>
      <el-table-column prop="xueduan_str" label="所属学段"></el-table-column>
      <el-table-column prop="district_names" label="所在地区"></el-table-column>
      <el-table-column prop="reason_text" label="操作" width="150px">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="deleteSchool(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row v-if="linkPage">
      <pagination
        :linkPage="linkPage"
        :enableEvent="true"
        @change="watchPageChange"
      ></pagination>
    </el-row>
  </el-card>
</template>
<style scoped>
.el-select {
  width: 130px;
}
.el-input {
  width: 330px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<script>
import Pagination from "~/widgets/Pagination.vue";
import elietschool from "~/services/elietschool";
import bus from "~/common/eventBus";
export default {
  name: "HideSchool",
  components: {
    Pagination,
  },
  props: {
    customer_id: {
      type: Number | String,
      required: true,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
      linkPage: null,
    };
  },
  created() {
    this.isShow = this.display;
    this.getList({ customer_id: parseInt(this.customer_id) });
  },
  methods: {
    getList(params) {
      this.loading = true;
      elietschool.getHideList(params).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.list = res.data;
          this.linkPage = res._meta;
        }
      });
    },

    deleteSchool(row) {
      this.$confirm(
        "是否将隐藏学校移除?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          var params = {
            customer_id: parseInt(this.customer_id),
            hide_customer_id: row.id,
          };
          elietschool.delete(params).then((res) => {
            if (res.code) {
              this.$message({ type: "error", message: res.msg });
              return false;
            }
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.getList({ customer_id: parseInt(this.customer_id) });
            return true;
          });
          this.loading = false;
        });
    },

    /**
     * 监听分页改变事件
     * @param pageParams
     */
    watchPageChange(pageParams) {
      let params = {
        customer_id: parseInt(this.customer_id),
        page: pageParams["page"],
        perPage: pageParams["perPage"],
      };
      this.getList(params);
    },
  },
  mounted() {
    bus.$on('refresh', data => {
      this.getList({ customer_id: parseInt(this.customer_id) });
    })
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/order/jiaoben/hideSchool.vue